import { Color, FontSize, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StepNumber = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${Color.Black};
  color: ${Color.White};
  font-size: ${FontSize.TextBodyMD};
  font-weight: bold;
`

export const StepLine = styled.div`
  width: 2px;
  height: 100%;
  min-height: 54px;
  margin-block: ${Spacing.S8};
  background-color: ${Color.Lavender600};
`
